import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  BADI_COLORS,
  Text,
  LinkButton,
  Icon,
  Flex,
} from "@badi/badi-components";
import { getIsIOS } from "datamodel/Device/selectors";
import { translate } from "base/shared/Localization";
import { getDownloadAppLink } from "base/shared/app-links";
import { isBannerVisible, removeBanner } from "./utils";
import { CloseIconWrapper, Root } from "./styled-components";

const DownloadAppBanner = ({ onLayoutChange }) => {
  const [visible, setVisible] = useState(false);
  const isIOS = useSelector(getIsIOS);

  const handleClose = () => {
    removeBanner();
    setVisible(false);
    onLayoutChange(0);
  };

  useEffect(() => {
    const banner = isBannerVisible();

    if (banner) {
      setVisible(true);
      onLayoutChange(16.5);
    }
  }, []);

  if (!visible) {
    return null;
  }

  return (
    <Flex as={Root} direction="column" gutter={2}>
      <Text
        body="12-Bold"
        color={BADI_COLORS.NEUTRAL.NEUTRAL_00}
        dataQa="download-banner-title"
      >
        {translate("download_app.banner.title")}
      </Text>
      <LinkButton
        data-qa="download-app-link"
        href={getDownloadAppLink({ ios: isIOS })}
        rel="noopener noreferrer"
        size="small"
        target="_blank"
        variant="primary"
      >
        {translate("download_app.banner.button")}
      </LinkButton>
      <CloseIconWrapper
        data-qa="download-app-close"
        onClick={handleClose}
        type="button"
      >
        <Icon
          color={BADI_COLORS.NEUTRAL.NEUTRAL_00}
          height={16}
          name="close"
          width={16}
        />
      </CloseIconWrapper>
    </Flex>
  );
};

DownloadAppBanner.propTypes = {
  onLayoutChange: PropTypes.func.isRequired,
};

export default DownloadAppBanner;
